import { Stack, Dialog, IconButton, styled } from '../../../base';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
        position: 'relative',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
    },
}));

export const StyledCloseButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(1),
    insetInlineEnd: theme.spacing(1),
}));

export const StyledContent = styled(Stack)(({ theme }) => ({
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
}));

export const StyledActions = styled(Stack)(({ theme }) => ({
    justifyContent: 'center',
    padding: theme.spacing(3),
}));
